module.exports = __webpack_public_path__ + "analysis.svg";